<div class="variance-override-dialog">
  <mat-toolbar color="warn">
    <mat-icon>warning</mat-icon>
    <h3>{{ 'varianceDetected' | translate }}</h3>
  </mat-toolbar>

  <mat-dialog-content>
    <p class="description">{{ 'varianceDescription' | translate }}</p>

    <div class="table-container">
      <table mat-table [dataSource]="data.items" class="variance-table">
        <!-- Product Name Column -->
        <ng-container matColumnDef="prdNameEn">
          <th mat-header-cell *matHeaderCellDef>{{ 'product' | translate }}</th>
          <td mat-cell *matCellDef="let item">{{ item.prdNameEn }}</td>
        </ng-container>

        <!-- SKU Column -->
        <ng-container matColumnDef="prdCode">
          <th mat-header-cell *matHeaderCellDef>{{ 'sku' | translate }}</th>
          <td mat-cell *matCellDef="let item">{{ item.prdCode }}</td>
        </ng-container>

        <!-- Storage Column -->
        <ng-container matColumnDef="storagePath">
          <th mat-header-cell *matHeaderCellDef>{{ 'storage' | translate }}</th>
          <td mat-cell *matCellDef="let item">{{ item.storagePath || '-' }}</td>
        </ng-container>

        <!-- Count Column -->
        <ng-container matColumnDef="countedQty">
          <th mat-header-cell *matHeaderCellDef>{{ 'counted' | translate }}</th>
          <td mat-cell *matCellDef="let item">{{ item.countedQty }}</td>
        </ng-container>

        <!-- Onhand Column -->
        <ng-container matColumnDef="onhandQty">
          <th mat-header-cell *matHeaderCellDef>{{ 'onhand' | translate }}</th>
          <td mat-cell *matCellDef="let item">{{ item.onhandQty }}</td>
        </ng-container>

        <!-- Variance Column -->
        <ng-container matColumnDef="variance">
          <th mat-header-cell *matHeaderCellDef>{{ 'variance' | translate }}</th>
          <td mat-cell *matCellDef="let item" [ngClass]="getVarianceClass(item.variance)">
            <span class="variance-value">
              {{ item.variance > 0 ? '+' : '' }}{{ item.variance }}
              <mat-icon *ngIf="item.variance !== 0" class="variance-icon">
                {{ getVarianceIcon(item.variance) }}
              </mat-icon>
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <div class="total-variance">
      {{ 'totalItemsWithVariance' | translate }}: <strong>{{ data.items.length }}</strong>
    </div>

    <mat-divider></mat-divider>

    <div class="override-section">
      <mat-checkbox [(ngModel)]="overrideOnhand" color="primary">
        {{ 'overrideOnhandWithCount' | translate }}
      </mat-checkbox>

      <mat-form-field *ngIf="overrideOnhand" appearance="outline" class="message-field">
        <mat-label>{{ 'overrideMessage' | translate }} ({{ 'optional' | translate }})</mat-label>
        <textarea matInput
                  [(ngModel)]="overrideMessage"
                  rows="3"
                  maxlength="500"
                  placeholder="{{ 'overrideMessagePlaceholder' | translate }}"></textarea>
        <mat-hint align="end">{{ overrideMessage.length }}/500</mat-hint>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button mat-button color="secondary" (click)="onCancel()">
      {{ 'cancel' | translate }}
    </button>
    <button mat-stroked-button color="primary" (click)="onFinalizeOnly()">
      {{ 'finalizeOnly' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="onOverrideAndFinalize()" [disabled]="!overrideOnhand">
      {{ 'overrideAndFinalize' | translate }}
    </button>
  </mat-dialog-actions>
</div>
